<script setup lang="ts">

type CsChangeProviderCardStatusResponse = {
	success: boolean;
	item?: any;
	message?: string;
};

const props = defineProps<{
	row: any
}>()

const emit = defineEmits<{
	update: []
}>()

const { confirm_modal_show } = useConfirmModal();
const { t } = useI18n();
const api = useApi();
const toast = useToast()

async function show_confirm_dialog__cs_change_provider_card_status(card: any, new_status: string) {

	console.log('show_confirm_dialog__cs_change_provider_card_status', card, new_status)
	
	const result = await confirm_modal_show({
		title: 'Change Provider Card Status',
		text: `Are you sure you want to change the provider card status to "${new_status}" for card: **** ${card.label}?`,
	})

	console.log('cs_change_provider_card_status', result)

	if (result) {

		try {

			const response = await api.post<CsChangeProviderCardStatusResponse>('/api/cs/change_provider_card_status', {
				_id: card._id,
				status: new_status,
			})

			if (response.success) {
				emit('update')
			} else {
				toast.add({
					title: t('error'),
					description: response.message,
					color: 'red',
					timeout: 2000,
				})
			}

		} catch (error) {
			console.error('cs_change_provider_card_status', error)
			toast.add({
				title: t('error'),
				description: `${error}`,
				color: 'red',
				timeout: 2000,
			})
		}
	} else {
		// Пользователь нажал "Отмена" или закрыл модальное окно
		console.log('Операция отменена')
	}
}
</script>
<template>
    <div v-if="row.provider_card_status">
        <UBadge
            v-if="row.provider_card_status === 'active'"
            :color="'green'"
            :label="$t('active')"
            variant="soft"
            @click="show_confirm_dialog__cs_change_provider_card_status(row, 'inactive')"
        />
        <UBadge
            v-else-if="row.provider_card_status === 'inactive'"
            :color="'yellow'"
            :label="$t('inactive')"
            variant="soft"
            @click="show_confirm_dialog__cs_change_provider_card_status(row, 'active')"
        />
        <UBadge
            v-else-if="row.provider_card_status === 'close'"
            :color="'black'"
            label="Closed"
            variant="soft"
        />
    </div>
    <div v-else>
        <UBadge
            v-if="row.status === 'active'"
            :color="'green'"
            :label="$t('active')"
            variant="solid"
        />
        <UBadge
            v-else-if="row.status === 'inactive'"
            :color="'yellow'"
            :label="$t('inactive')"
            variant="solid"
        />
        <UBadge
            v-else-if="row.status === 'close'"
            :color="'black'"
            label="Closed"
            variant="solid"
        />
    </div>
</template>